import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import WhatIs from './components/WhatIs';
import ComparisonTable from './components/ComparisonTable';
import CategoryGrid from './components/CategoryGrid';
import WhyUs from './components/WhyUs';
import Safety from './components/Safety';
import FeaturedProducts from './components/FeaturedProducts';
import FAQComponent from './components/FAQ';
import CTA from './components/CTA';
import ArticlePreview from './components/ArticlePreview';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <WhatIs />
        <ComparisonTable />
        <CategoryGrid />
        <WhyUs />
        <Safety />
        <FeaturedProducts />
        <CTA />
        <ArticlePreview />
        <FAQComponent />
      </main>
      <Footer />
    </>
  );
}